import React from 'react';

import {
  SCHEDULE_SECTION,
  INITIAL_ACTIVITY_FORM_DATA
} from 'pages/create-activity/constants';

import { ScheduleDate, ScheduleDateTime, SchedulePass } from 'components';

import { useStyles } from './styles';

const ScheduleCreate = ({
  selectedTabIndex,
  onSubmit,
  getPricesData,
  setSubmitButton,
  isUpdate
}) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      {selectedTabIndex === SCHEDULE_SECTION.dateNoTime && (
        <ScheduleDate
          onSubmit={values => onSubmit(values, 'scheduleDateForm')}
          getPricesData={values => getPricesData(values, 'pricesDailyForm')}
          initialValues={INITIAL_ACTIVITY_FORM_DATA['scheduleDateForm']}
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      )}
      {selectedTabIndex === SCHEDULE_SECTION.dateTime && (
        <ScheduleDateTime
          onSubmit={values => onSubmit(values, 'scheduleDateTimeForm')}
          getPricesData={values =>
            getPricesData(values, 'pricesDailyScheduleForm')
          }
          initialValues={INITIAL_ACTIVITY_FORM_DATA['scheduleDateTimeForm']}
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      )}
      {selectedTabIndex === SCHEDULE_SECTION.pass && (
        <SchedulePass
          onSubmit={values => onSubmit(values, 'schedulePassForm')}
          initialValues={INITIAL_ACTIVITY_FORM_DATA['schedulePassForm']}
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      )}
    </div>
  );
};

export default ScheduleCreate;
